import { render } from "./addUser.vue?vue&type=template&id=97226d72&scoped=true"
import script from "./addUser.vue?vue&type=script&lang=js"
export * from "./addUser.vue?vue&type=script&lang=js"

import "./addUser.vue?vue&type=style&index=0&id=97226d72&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97226d72"]])

export default __exports__